// @ts-nocheck -- TypeScript migration in progress: bulk-renamed from .js and not
// yet typed. Remove this directive and add real types when converting this
// module. Backlog: grep -rl "@ts-nocheck" src. See docs/typescript-migration.md.
export function defaultAppConfig() {
  return { demoMode: false, readOnly: false, databaseName: "", askGraphEnabled: true, maintenanceEnabled: false, retentionDisclosureEnabled: false, newUiEnabled: true, localMailUiUrl: null };
}

export async function fetchAppConfig(endpoint, {
  warn = (message) => console.warn(message),
} = {}) {
  try {
    const response = await fetch(endpoint, { cache: "no-store" });
    if (!response.ok) throw new Error(`App config API HTTP ${response.status}`);
    const payload = await response.json();
    return {
      demoMode: Boolean(payload?.demoMode),
      readOnly: Boolean(payload?.readOnly ?? payload?.demoMode),
      databaseName: String(payload?.databaseName ?? ""),
      askGraphEnabled: payload?.askGraphEnabled !== false,
      // Maintenance tab launch gate (issue #143): default off — the real
      // Maintenance page only renders when the server confirms the flag.
      maintenanceEnabled: payload?.maintenanceEnabled === true,
      // Deleted-flight retention disclosure gate (issue #405): default off -
      // the delete dialog only adds the retention line when the server
      // confirms the workflow is live.
      retentionDisclosureEnabled: payload?.retentionDisclosureEnabled === true,
      // "New UI" navigation shell: default on. Only an explicit false from
      // the server (admin toggled the flag off) falls back to the old UI.
      newUiEnabled: payload?.newUiEnabled !== false,
      // Local dev only: the Mailpit inbox URL for the floating mail shortcut.
      // Null on dev/prod (server only sets it for a loopback SMTP host).
      localMailUiUrl: typeof payload?.localMailUiUrl === "string" && payload.localMailUiUrl.trim()
        ? payload.localMailUiUrl.trim()
        : null,
    };
  } catch (error) {
    warn(`Could not load app config: ${error.message}`);
    return defaultAppConfig();
  }
}
